module.exports = __webpack_public_path__ + "static/careerPath-dd5e7ff4d7b2b0965519a7364e98a85c.png";